module.exports = __webpack_public_path__ + "img/icon_checkmark-success.1b0e1bf1.svg";